/**
 * The dashboard's router seam. The page itself is router-free; this component
 * is the only place it learns how to navigate.
 *
 * The route is declared in src/router.tsx rather than through a factory here:
 * the route tree's literal types are what give `to="/login"` its typed search
 * params, and a factory returning `AnyRoute[]` erases them for the whole tree.
 */
import { useNavigate } from "@tanstack/react-router";

import { useSession } from "@/lib/session/use-session";

import { DashboardPage } from "./dashboard-page";

export function DashboardRoute() {
  const navigate = useNavigate();
  const { company } = useSession();
  // A company with no ledger settings has no base currency; the tiles that
  // need one are skipped rather than shown in an invented currency.
  return (
    <DashboardPage
      currency={company?.base_currency ?? ""}
      onOpen={(path) => void navigate({ to: path } as never)}
    />
  );
}
